import { Chip } from "@mui/material";
import { palette } from "../../theme/palette";
import { withStyles } from "@mui/styles";

const StyledChip = withStyles({
  root: {
    borderRadius: "4px",
    margin: "4px",
    height: "17px",
    width: "30px",
    backgroundColor: palette.typography.white.high,
  },
  label: {
    fontSize: "11px",
    padding: 0,
  },
})(Chip);

export default StyledChip;
